import React, { useState } from "react";
import "./contact.css";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    reason: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    alert("Thanks for reaching out. We'll get back to you soon!");
    setFormData({ name: "", email: "", reason: "", message: "" });
  };

  const contactReasons = [
    "Request a Demo",
    "Pricing Inquiry",
    "Integration Support",
    "Ask About the Engine",
    "Report an Issue",
    "General Question",
  ];

  return (
    <div className="contact-page" id="contact">
      <div className="integrations-header">
        <h2>Contact Us</h2>
        <p>
          Have questions or ready to get started? Reach out — we’re here to
          help.
        </p>
      </div>

      <div className="contact-form-container">
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <input
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <input
              name="email"
              type="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <select
              name="reason"
              value={formData.reason}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                Select a reason
              </option>
              {contactReasons.map((r, i) => (
                <option key={i} value={r}>
                  {r}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <textarea
              name="message"
              rows="5"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-button">
            <span>Send Message</span>
          </button>
        </form>
        <div
          style={{
            marginTop: "20px",
            display: "flex",
            gap: "10px",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <p>
            <MailOutlined style={{ marginRight: 10 }} /> info@roradar.com
          </p>
          <p>
            <PhoneOutlined style={{ marginRight: 10 }} /> +1 602-800-8789
          </p>
        </div>
      </div>
    </div>
  );
}

export default Contact;
